<template>
    <div>
        <GmapMap
            id="map-canvas"
            :center="{lat: lat, lng: lng}"
            :zoom="7"
            style="width: 100%; height: 100%"
        >
            <GmapInfoWindow
                :position="selectedStore.position"
                :options="infoWindowOptions"
                :opened="infoWindowOpened"
                @closeclick="infoWindowClose"
                style="height: auto"
            >
            <span>
                <b>{{ selectedStore.address.name }}</b>
                <br>{{ selectedStore.address.postalCode }} {{ selectedStore.address.city }}, {{ selectedStore.address.street }} {{ selectedStore.address.houseNumber }}
                <br>{{ __('Telefonszám')}}: {{ selectedStore.phone }}
                <br>{{ __('E-mail') }}:
                <a :href="'mailto:' + selectedStore.email" tabindex="0">{{ selectedStore.email }}</a>
                <br><br>{{ __('Nyitva tartás') }}:
                <br>
                <p v-html="selectedStore.openingTimes"></p>
            </span>
            </GmapInfoWindow>

            <GmapMarker
                v-for="store in stores"
                :key="store.id"
                :position="store.position"
                :clickable="true"
                :draggable="false"
                :icon="store.storeType.icon"
                @click="selected(store)"
            ></GmapMarker>
        </GmapMap>
    </div>
</template>

<script>
export default {
    name: 'Maps',
    props: {
        stores: {
            type: Array,
            default: () => []
        },
        lat: {
            type: Number,
            required: true,
        },
        lng: {
            type: Number,
            required: true,
        },
    },

    data() {
        return {
            selectedStore: {
                position: null,
                address: {
                    name: '',
                    postalCode: '',
                    city: '',
                    street: '',
                    houseNumber: '',
                }
            },
            infoWindowOptions: {
                pixelOffset: {
                    width: 0,
                    height: -35,
                }
            },
            infoWindowOpened: false,
        }
    },


    methods: {
        selected(store) {
            this.selectedStore = store
            this.infoWindowOpened = true
        },

        infoWindowClose() {
            this.selectedStore = this.defaultAddress()
            this.infoWindowOpened = false
        },

        defaultAddress(){
            return {
                position: null,
                address: {
                    name: '',
                    postalCode: '',
                    city: '',
                    street: '',
                    houseNumber: '',
                }
            }
        }
    },
}
</script>

<style scoped>

</style>
